import { render, staticRenderFns } from "./ConfiguracaoSistema.vue?vue&type=template&id=046c07e8"
import script from "./ConfiguracaoSistema.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoSistema.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports